export function parse(s:String, detailData?: any[], detail_title_field?: any, legend_field?: any){

    let ancestors = [];
    let tree:any = {};
    let nodeCount:number = 0;

    let colorCategoryValue:string[] = [];
    let colorCategoryMap:any = {};

    if(s !== undefined){
        const tokens:String[] = s.split(/\s*(;|\(|\)|,|:)\s*/);

        for (let i=0; i<tokens.length; i++) {
            const token:String = tokens[i];
            switch (token) {
                case '(': // new branchset
                    let subtree1 = {};
                    tree.branchset = [subtree1];
                    ancestors.push(tree);
                    tree = subtree1;
                    //nodeCount++;
                break;
                case ',': // another branch
                    let subtree2 = {};
                    ancestors[ancestors.length-1].branchset.push(subtree2);
                    tree = subtree2;
                    nodeCount++;
                break;
                case ')': // optional name next
                tree = ancestors.pop();
                break;
                case ':': // optional length next
                break;
                default:
                let x = tokens[i-1];
                if (x === ')' || x === '(' || x === ',') {
                    tree.name = token;

                    if(detailData !== undefined && detail_title_field !== undefined){
                        detailData.forEach(detailData => {
                            if(tree.name === detailData[detail_title_field.source_filed]){
                                tree.detailData = detailData;

                                if(legend_field !== undefined) {
                                    if(detailData[legend_field] !== undefined && colorCategoryMap[detailData[legend_field]] === undefined) {
                                        colorCategoryMap[detailData[legend_field]] = detailData[legend_field];
                                        colorCategoryValue.push(detailData[legend_field]);
                                    }
                                }

                                return true;
                            }
                        });
                    }

                } else if (x === ':') {
                    tree.length = parseFloat(token.toString());
                }
            }
        }

    }

    return [tree, nodeCount, colorCategoryValue];
}
